export default __webpack_public_path__ + "static/media/mail_icon.e1b6b02a.svg";